const RAIN_STORM_SNOW_ICONS = new Set([
  'cloud.rain.fill',
  'cloud.heavyrain.fill',
  'cloud.bolt.rain.fill',
  'cloud.snow.fill',
  'cloud.sleet.fill',
  'cloud.drizzle.fill',
]);

export function weatherCodeToCondition(code: number): string {
  switch (code) {
    case 0:
      return 'Clear';
    case 1:
    case 2:
    case 3:
      return 'Partly Cloudy';
    case 45:
    case 48:
      return 'Foggy';
    case 51:
    case 52:
    case 53:
    case 54:
    case 55:
    case 56:
    case 57:
      return 'Drizzle';
    case 61:
    case 62:
    case 63:
    case 64:
    case 65:
    case 66:
    case 67:
      return 'Rainy';
    case 71:
    case 72:
    case 73:
    case 74:
    case 75:
    case 76:
    case 77:
      return 'Snowy';
    case 80:
    case 81:
    case 82:
      return 'Showers';
    case 85:
    case 86:
      return 'Snow Showers';
    case 95:
    case 96:
    case 97:
    case 98:
    case 99:
      return 'Thunderstorm';
    default:
      return 'Cloudy';
  }
}

export function weatherCodeToIcon(code: number, isDay: boolean = true): string {
  switch (code) {
    case 0:
      return isDay ? 'sun.max.fill' : 'moon.stars.fill';
    case 1:
    case 2:
    case 3:
      return isDay ? 'cloud.sun.fill' : 'cloud.moon.fill';
    case 45:
    case 48:
      return 'cloud.fog.fill';
    case 51:
    case 53:
    case 55:
      return 'cloud.drizzle.fill';
    case 56:
    case 57:
      return 'cloud.sleet.fill';
    case 61:
    case 63:
    case 65:
      return 'cloud.rain.fill';
    case 66:
    case 67:
      return 'cloud.sleet.fill';
    case 71:
    case 73:
    case 75:
      return 'cloud.snow.fill';
    case 77:
      return 'cloud.snow.fill';
    case 80:
    case 81:
    case 82:
      return 'cloud.heavyrain.fill';
    case 85:
    case 86:
      return 'cloud.snow.fill';
    case 95:
    case 96:
    case 99:
      return 'cloud.bolt.rain.fill';
    default:
      return 'cloud.fill';
  }
}

/** Open-Meteo is_day: 1 = day, 0 = night. */
export function isDaylightFromOpenMeteo(value: number | null | undefined): boolean {
  return value !== 0;
}

/** True when cached hourly rows predate is_day (all null/undefined) — bust cache. */
export function shouldInvalidateHourlyCacheLackingIsDay(
  rows: Array<{ isDay?: boolean | null }>
): boolean {
  if (rows.length === 0) return false;
  return rows.every((row) => row.isDay == null);
}

/** Override icon when precipitation probability is high (mirrors iOS HourlyWeatherIconResolver). */
export function resolveHourlyIcon(iconName: string, precipProbability: number): string {
  if (RAIN_STORM_SNOW_ICONS.has(iconName)) {
    return iconName;
  }
  if (precipProbability >= 50) {
    return 'cloud.rain.fill';
  }
  return iconName;
}

/** Map SF Symbol names to Lucide icon component names for WeatherConditionIcon. */
export function weatherSfToLucide(iconName: string): string {
  switch (iconName) {
    case 'sun.max.fill':
      return 'Sun';
    case 'moon.stars.fill':
      return 'Moon';
    case 'cloud.sun.fill':
      return 'CloudSun';
    case 'cloud.moon.fill':
      return 'CloudMoon';
    case 'cloud.fog.fill':
      return 'CloudFog';
    case 'cloud.drizzle.fill':
    case 'cloud.sleet.fill':
      return 'CloudDrizzle';
    case 'cloud.rain.fill':
    case 'cloud.heavyrain.fill':
      return 'CloudRain';
    case 'cloud.snow.fill':
      return 'CloudSnow';
    case 'cloud.bolt.rain.fill':
      return 'CloudLightning';
    default:
      return 'Cloud';
  }
}
